<template>
  <div>
    <modal :show.sync="SHOW_OTP_MODAL" class="modal-primary" :show-close="false" header-classes="justify-content-center" type="mini">
      <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="fa fa-mobile-alt"></i>
      </div>
      <p v-if="!INVALID_OTP">{{$t('message.Enter the OTP sent to your contact details')}}</p>
      <p v-if="INVALID_OTP">{{$t('message.Invalid OTP')}}</p>
      <div style="display: flex; flex-direction: row; justify-content: center">
        <v-otp-input ref="otpInput" input-classes="otp-input" separator="-" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete" v-if="SHOW_OTP_MODAL" />

        <!-- <button @click="handleClearInput()">Clear Input</button> -->
      </div>
      <template slot="footer">
        <n-button type="primary" round @click.native="
            $store.commit('setState', {
              stateName: 'SHOW_OTP_MODAL',
              stateValue: false,
            })
          " v-if="!resendTimer">{{$t('message.Cancel')}}</n-button>
        <n-button type="primary" round @click.native="getOtp(identifier)" v-if="!resendTimer">{{$t('message.Resend')}}</n-button>
        <span v-if="resendTimer">{{$t('message.Resend in')}}{{ resendTimer }} </span>
      </template>
    </modal>
  </div>
</template>

<script>
import OtpInput from "@bachdgvn/vue-otp-input";

export default {
  name: "otp-modal",

  components: {
    Modal: () => import("../../../components/Modal"),
    "v-otp-input": OtpInput,
  },

  data() {
    return {
      resendTimer: null,
      repeatTimer: null,
      INVALID_OTP: false,
    };
  },

  props: ["identifier"],

  computed: {
    SHOW_OTP_MODAL() {
      return this.$store.state.SHOW_OTP_MODAL;
    },
  },

  methods: {
    async getOtp(identifier) {
      try {
        clearTimeout(this.repeatTimer);
        let response = await this.$store.dispatch("generateOtp", {
          identifier: identifier,
        });

        if (response.data) {
          this.$store.commit("setState", {
            stateName: "SHOW_OTP_MODAL",
            stateValue: true,
          });
          this.timer(60);
        } else {
          this.$emit("otp-error");
        }
      } catch (err) {
        console.log(err);
        this.$emit("otp-error");
      }
    },
    timer(remaining) {
      let that = this;
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      this.resendTimer = m + ":" + s;
      remaining -= 1;

      if (remaining >= 0) {
        this.repeatTimer = setTimeout(function () {
          that.timer(remaining);
        }, 1000);
        return;
      }

      this.resendTimer = null;
    },

    async handleOnComplete(value) {
      let response = await this.$store.dispatch("validateOtp", {
        identifier: this.identifier,
        otp: value,
      });

      if (response) {
        this.$emit("otp-success", response);
      } else {
        this.INVALID_OTP = true;
        document.getElementsByClassName("modal-content")[0].className =
          "modal-content animated shake";
        setTimeout(() => {
          document.getElementsByClassName("modal-content")[0].className =
            "modal-content";
        }, 1000);
      }
    },
    handleOnChange(value) {
      this.INVALID_OTP = false;
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
  },
};
</script>

<style scoped>
/deep/ .otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/deep/ .otp-input .error {
  border: 1px solid red !important;
}
/deep/ .otp-input::-webkit-inner-spin-button,
/deep/ .otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/deep/ .otp-number-input {
  width: 40px;
}

/deep/ .modal.modal-mini .modal-dialog {
  max-width: 430px;
}
/deep/ .modal.fade.modal-primary.show.d-block.modal-mini {
  pointer-events: none;
}
/deep/.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
/deep/.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
@media screen and (max-width: 375px) {
  /deep/ input.otp-input {
    margin: 0px;
  }
}
</style>
